import pptPreview from './src/main'

pptPreview.install = function (Vue) {
  Vue.component(pptPreview.name, pptPreview)
}

export default pptPreview
